import { ref } from 'vue';

const isVisible = ref(false);
const activeSection = ref(null);

/**
 * Global Settings modal state — shell-level administrative overlay.
 * Permissions and section data live elsewhere; this composable is state only.
 */
export function useGlobalSettings() {
  const setActiveSection = (key) => {
    activeSection.value = key;
  };

  const open = (sectionKey = null) => {
    if (sectionKey != null) {
      activeSection.value = sectionKey;
    }
    isVisible.value = true;
  };

  const close = () => {
    isVisible.value = false;
  };

  return {
    isVisible,
    activeSection,
    open,
    close,
    setActiveSection,
  };
}
